import React from "react";
import Chip from "@mui/material/Chip";
import { DataRow, Cell, ActionButton } from "utils/ui";

const STATUS_COLOR = {
  DRAFT: "default",
  IN_REVIEW: "warning",
  ACTIVE: "success",
  ARCHIVED: "default",
};

export default function SchemeRow({ scheme, index, onEdit, onSubmit, onPublish, onArchive }) {
  const canEdit = scheme.status === "DRAFT" || scheme.status === "IN_REVIEW";
  const canAmend = scheme.status === "ACTIVE";
  const canSubmit = scheme.status === "DRAFT";
  const canPublish = scheme.status === "DRAFT" || scheme.status === "IN_REVIEW";
  const canArchive = scheme.status === "ACTIVE";

  return (
    <DataRow>
      <Cell variant="index" value={index + 1} />
      <Cell primary={scheme.name} secondary={scheme.brand?.name} />
      <Cell value={scheme.periodFrom} />
      <Cell value={scheme.periodTo} />
      <Cell>
        <Chip size="small" label={scheme.status} color={STATUS_COLOR[scheme.status] || "default"} />
      </Cell>
      <Cell center value={scheme.publishVersion ?? "—"} />
      <Cell>
        <div className="flex flex-wrap gap-1.5">
          {(canEdit || canAmend) && (
            <ActionButton size="small" variant="secondary" onClick={() => onEdit(scheme)}>
              {canAmend ? "Amend" : "Edit"}
            </ActionButton>
          )}
          {canSubmit && (
            <ActionButton size="small" variant="ghost" onClick={() => onSubmit(scheme)}>
              Submit for Review
            </ActionButton>
          )}
          {canPublish && (
            <ActionButton size="small" variant="success" onClick={() => onPublish(scheme)}>
              Publish
            </ActionButton>
          )}
          {canArchive && (
            <ActionButton size="small" variant="danger" onClick={() => onArchive(scheme)}>
              Archive
            </ActionButton>
          )}
          {scheme.status === "ARCHIVED" && (
            <ActionButton size="small" variant="ghost" onClick={() => onEdit(scheme)}>
              View
            </ActionButton>
          )}
        </div>
      </Cell>
    </DataRow>
  );
}
